export enum AppLanguages {
  en = 'en',
  ru = 'ru',
}
